// document.title = "个人中心";
import { defineComponent, reactive } from "vue";
import { showNotify, showImagePreview } from "vant";
export default defineComponent({
  name: "My",
  setup() {
    let userInfo = reactive({
      name: "",
      jobNum: "",
      deptName: "",
      photoPath: "",
      amount: 0
    });
    // const accessToken = useRoute().query?.accessToken ?? localStorage.getItem("token");
    // const router = useRouter();
    // if (!accessToken) {
    //   showNotify({ type: "warning", message: "accessToken错误" });
    // } else {
    // }
    // localStorage.setItem("token", accessToken + "");
    const user = JSON.parse(localStorage.getItem("userInfo") || "{}");
    userInfo.amount = user === null || user === void 0 ? void 0 : user.amount;
    userInfo.name = user === null || user === void 0 ? void 0 : user.name;
    userInfo.jobNum = user === null || user === void 0 ? void 0 : user.jobNum;
    userInfo.deptName = user === null || user === void 0 ? void 0 : user.deptName;
    userInfo.photoPath = user === null || user === void 0 ? void 0 : user.photoPath;
    // console.log("my", accessToken);
    // getInfo().then(({ code, data }) => {
    //   if (code === 200) {
    //     if (!data?.personId) {
    //       router.push("/bind");
    //       return;
    //     }
    //     // localStorage.setItem("userInfo", JSON.stringify(data));
    //     userInfo.amount = data?.amount;
    //     userInfo.name = data?.name;
    //     userInfo.jobNum = data?.jobNum;
    //     userInfo.deptName = data?.deptName;
    //     userInfo.photoPath = data?.photoPath;
    //   }
    // });
    // 头像预览
    const preview = () => {
      if (userInfo.photoPath) {
        showImagePreview([userInfo.photoPath]);
      }
    };
    // 给予无权限提醒
    const auto = () => {
      showNotify({
        type: "warning",
        message: "您暂无此功能权限！"
      });
    };
    return {
      userInfo,
      preview,
      auto
    };
  }
});